import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type EventConfirmedNotificationProps = {
  notification: CHQ.NotificationEventConfirmed;
};

const EventConfirmedNotification: React.FC<EventConfirmedNotificationProps> = ({
  notification: { entity }
}) => (
  <NotificationBody badge="calendar">
    <Trans>You are confirmed to attend the event:</Trans> {entity?.event?.name}
  </NotificationBody>
);

export default EventConfirmedNotification;
